import { FILE_INLINE_CARD_PARTS } from './fileInlineCardParts';
import type { FileInlineCardStyleConfig } from './types';

const BASE_STYLE = {
  container: {
    display: 'inline-flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: 0.25,
    padding: 0.25,
    paddingRight: 0.5,
    minWidth: 2.5,
    height: 3,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'separator.border',
    borderRadius: 'sm',
    fontSize: 'sm',
    lineHeight: 'sm',
    fontWeight: 'medium',
    color: 'interaction.main',
    backgroundColor: 'page.surface',
    transitionProperty: 'common',
    transitionDuration: '0.2s',
    _focus: {
      boxShadow: 'focus',
    },
    _hover: {
      backgroundColor: 'interaction.surfaceHover',
      borderColor: 'interaction.hover',
      color: 'interaction.hover',
      textDecoration: 'none',
    },
    _active: {
      backgroundColor: 'interaction.surfaceActive',
      borderColor: 'interaction.active',
      color: 'interaction.active',
    },
    _disabled: {
      backgroundColor: 'page.surface',
      borderColor: 'separator.border',
      color: 'feature.placeholder',
      cursor: 'not-allowed',
    },
  },
  label: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexShrink: 1,
  },
  icon: {
    boxSize: 2,
    flexShrink: 0,
  },
};

export const FILE_INLINE_CARD_STYLE_CONFIG: FileInlineCardStyleConfig = {
  parts: FILE_INLINE_CARD_PARTS,
  baseStyle: BASE_STYLE,
};
